import { currentPage, initNewSection } from '../common/layout';
import { banners } from '../common/utils/fn';
import { getM1FindVehicleEu, getM1FindVehicleUs } from '../common/shop/m1-find-vehicle-widget-loader';
import { getCoralCommentsCountUpdate } from '../common/utils/coral-requests-loader';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
  
    let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
    loadMoreButton?.addEventListener('click', (event) => {
      event.preventDefault();
      getLoadMoreContent().then((api) => {
        api.loadMoreButtonNew(loadMoreButton);
      });
    });

    getCoralCommentsCountUpdate().then((api) => {
      api.coralCommentsCountUpdate();
    });
    getM1FindVehicleEu().then((api) => {
        api.m1FindVehicleEu();
      });
      getM1FindVehicleUs().then((api) => {
        api.m1FindVehicleUs();
      });
}

currentPage.pageLoadMore = ($html, $btnBox) => {
    //$btnBox.replaceWith($html);
    initNewSection($html);
    // hybridLazyLoad();
    banners($html);

    let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
    loadMoreButton?.addEventListener('click', (event) => {
      event.preventDefault();
      getLoadMoreContent().then((api) => {
        api.loadMoreButtonNew(loadMoreButton);
      });
    });

    getCoralCommentsCountUpdate().then((api) => {
      api.coralCommentsCountUpdate();
    });
}